import { render, staticRenderFns } from "./AttachProperty.vue?vue&type=template&id=b9f7dd56"
import script from "./AttachProperty.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachProperty.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports